import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";
import contact from "../image/contact.webp";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="relative h-[600px]">
        <img src={contact} alt="" />
        <div className="absolute inset-0 z-20 flex h-full w-full flex-col items-center justify-center bg-black/10 text-center text-white">
          <p className="text-[50px]">Contact Us</p>
        </div>
      </div>
      <div className="mx-auto my-20 max-w-[800px] px-4 py-20">
        <p>Talk To A Real Person</p>
        <p>We're available Monday Through Friday, 10am to 5pm MDT</p>
        <div className="py-8">
          <div className="grid gap-8 md:grid-cols-2">
            <div>
              <p className="mb-3 text-[13px] uppercase tracking-[2px]">
                First Name
              </p>

              <input
                type="text"
                className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
              />
            </div>

            <div>
              <p className="mb-3 text-[13px] uppercase tracking-[2px]">
                Last Name
              </p>

              <input
                type="text"
                className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
              />
            </div>
          </div>

          <div className="mt-2">
            <p className="mb-3 text-[13px] uppercase tracking-[2px]">Email</p>

            <input
              type="email"
              className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
            />
          </div>

          <div className="mt-2">
            <p className="mb-3 text-[13px] uppercase tracking-[2px]">Subject</p>

            <input
              type="text"
              className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
            />
          </div>

          <div className="mt-2">
            <p className="mb-3 text-[13px] uppercase tracking-[2px]">Message</p>

            <textarea
              rows={6}
              className="w-full resize-none border border-gray-300 bg-transparent px-4 py-4 text-sm outline-none focus:border-black"
            />
          </div>

          <button className="mt-10 flex w-[200px] items-center justify-center bg-btn p-2 text-sm uppercase tracking-[2px] text-white transition hover:opacity-85">
            send
          </button>
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default ContactUs;
